import React from "react";
import HeaderNav from "../../header/header";
import {
    Button,
    Col,
    DatePicker,
    Form,
    Input,
    Layout,
    message,
    Modal,
    Row,
    Select,
    Spin,
    Table
} from "antd";
import moment from 'moment';
import "../css/SingleCreateFinancialClaim.css"
import {Option} from "antd/es/mentions";
import {
    basic_info,
    financial_claim_detail,
    financial_claim_search, financial_download_report,
} from "../../../requist";

const { Content } = Layout;

class ClaimReport extends React.Component{
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state={
            selectedRowKeys:[],
            isModalVisible:false,
            optionList:[],
            data:[],
            basic_info:'',
            detailData:null,
            searchParams:null,
            loading:false,
            diffYearError:false,
            diffMonthError:false,
        }
        this.columns = [
            {
                title: 'Dispute No',
                dataIndex: 'disputeNumber',
                width: 150,
            },
            {
                title: 'Dispute Type',
                dataIndex: 'disputeTypeDesc',
                width: 250,
            },
            {
                title: 'Claim Request No.',
                dataIndex: 'claimReqNo',
                width: 250,
            },
            {
                title: 'Claim ID',
                dataIndex: 'claimId',
                width: 150,
                render:((text,record)=>{
                    return <a onClick={()=>{
                        this.setState({isModalVisible:true})
                        let params={
                            claimId:text,
                            claimReqNo:record.claimReqNo
                        }
                        financial_claim_detail(params).then(res=>{
                            const {retCode,retMsg,data} = res;
                            if(retCode==='200'){
                                this.setState({detailData:data})
                            }else{
                                message.error(`${retMsg}`)
                            }
                        })
                    }
                    }>{text}</a>
                })
            },
            {
                title: 'Claim Category',
                dataIndex: 'claimCategory',
                width: 150,
            },
            {
                title: 'Claim Type',
                dataIndex: 'claimType',
                width: 150,
            },
            {
                title: 'Order Reason Description',
                dataIndex: 'claimTypeText',
                width: 250,
            },
            {
                title: 'Sales Org',
                dataIndex: 'salesOrg',
                width: 150,
            },
            {
                title: 'Channel',
                dataIndex: 'channel',
                width: 150,
            },
            {
                title: 'Sales Office',
                dataIndex: 'salesOffice',
                width: 150,
            },
            {
                title: 'Status',
                dataIndex: 'status',
                width: 150,
            },
            {
                title: 'Status Description',
                dataIndex: 'statusText',
                width: 250,
            },
            {
                title: 'Sold To Party',
                dataIndex: 'soldTo',
                width: 150,
            },
            {
                title: 'Sold to Customer Name',
                dataIndex: 'soldToText',
                width: 150,
            },
            {
                title: 'SBO-No/SOP Ref./LENOVO Ref',
                dataIndex: 'lenovoRef',
                width: 150,
            },
            {
                title: 'BP-Reference',
                dataIndex: 'bpRef',
                width: 250,
            },
            {
                title: 'Bill To Party',
                dataIndex: 'billTo',
                width: 250,
            },
            {
                title: 'Invoice No',
                dataIndex: 'invoiceNo',
                width: 250,
            },
            {
                title: 'Customer PO No.',
                dataIndex: 'poNumber',
                width: 250,
            },
            {
                title: 'Currency',
                dataIndex: 'currency',
                width: 150,
            },
            {
                title: 'Requested Delivery Date',
                dataIndex: 'reqDeliveryDate',
                width: 150,
            },
            {
                title: 'Pricing Date',
                dataIndex: 'pricingDate',
                width: 150,
            },
            {
                title: 'Claim Value',
                dataIndex: 'claimValue',
                width: 150,
            },
            {
                title: 'SO Number',
                dataIndex: 'soNumber',
                width: 150,
            },
            {
                title: 'Delivery Number',
                dataIndex: 'deliveryNumber',
                width: 150,
            },
            {
                title: 'Billing Number',
                dataIndex: 'billingNo',
                width: 150,
            },
            {
                title: 'Name of the Person who Created the Object',
                dataIndex: 'createdBy',
                width: 150,
            },
            {
                title: 'Date on Which the Record was Created',
                dataIndex: 'createdOn',
                width: 150,
            },
            {
                title: 'Name of the Person who Changed Object',
                dataIndex: 'changedBy',
                width: 150,
            },
            {
                title: 'Date of Last Change',
                dataIndex: 'changeDate',
                width: 150,
            },
            {
                title: 'Name of the Approval',
                dataIndex: 'approvedBy',
                width: 150,
            },
            {
                title: 'Date of Approval',
                dataIndex: 'approvedAt',
                width: 150,
            },
            {
                title: 'Comment',
                dataIndex: 'comment',
                width: 250,
            },
            {
                title: 'Billing Instruction',
                dataIndex: 'billingInstruction',
                width: 150,
            },
            {
                title: 'Ship To Party',
                dataIndex: 'shipTo',
                width: 150,
            },
            {
                title: 'Email',
                dataIndex: 'email',
                width: 250,
            },
            {
                title: 'Collection Address 1',
                dataIndex: 'street',
                width: 250,
            },
            {
                title: 'Collection Address 2',
                dataIndex: 'street2',
                width: 250,
            },
            {
                title: 'Zip Code',
                dataIndex: 'postalCode',
                width: 150,
            },
            {
                title: 'Division',
                dataIndex: 'division',
                width: 100,
            },
            {
                title: 'City',
                dataIndex: 'city',
                width: 100,
            },
            {
                title: 'Country',
                dataIndex: 'country',
                width: 100,
            },
            {
                title: 'Contact Person',
                dataIndex: 'contactPerson',
                width: 150,
            },
            {
                title: 'Phone Number',
                dataIndex: 'phoneNumber',
                width: 150,
            },
            {
                title: 'Date on Which SO Created',
                dataIndex: 'orderCreatedAt',
                width: 150,
            },
        ];
        this.columnsItem=[
            {
                title: 'Claim Item No',
                dataIndex: 'claimReqItem',
                width: 250,
            },
            {
                title: 'Material',
                dataIndex: 'partNumber',
                width: 250,
            },
            {
                title: 'Message',
                dataIndex: 'message',
                width: 250,
            },
            {
                title: 'Quantity',
                dataIndex: 'quantity',
                width: 250,
            },
            {
                title: 'End User Name',
                dataIndex: 'endUserName',
                width: 250,
            },
            {
                title: 'Unit Claim Value',
                dataIndex: 'unitClaimValue',
                width: 250,
            },
            {
                title: 'Claim Value',
                dataIndex: 'claimValue',
                width: 250,
            },
            {
                title: 'Serial Number',
                dataIndex: 'serialNumber',
                width: 250,
            },
            {
                title: 'Status',
                dataIndex: 'status',
                width: 250,
            },
            {
                title: 'SO Number',
                dataIndex: 'soNumber',
                width: 250,
            },
            {
                title: 'Delivery Number',
                dataIndex: 'deliveryNumber',
                width: 250,
            },
            {
                title: 'Billing Number',
                dataIndex: 'billingNo',
                width: 250,
            },
            {
                title: 'Processing Log',
                dataIndex: 'processingLog',
                width: 250,
            },
            {
                title: 'Deletion Indicator',
                dataIndex: 'deleteStatus',
                width: 250,
            },
        ]
    }
    componentWillMount(){
        let uesrId = window.localStorage.getItem('userId')
        if(!uesrId){
            message.warn('Please log in first!')
            this.props.history.push({
                pathname: '/disputeHome'
            })
        }
    }
    componentDidMount() {
        let we_dispute_types=[]
        // dispute_types().then((res)=>{
            basic_info().then((res)=>{
                let {data,retCode,retMsg} = res;
                if(retCode==="200"){
                    window.sessionStorage.setItem('basic_info', JSON.stringify(res.data))
                    this.setState({basic_info:data})
                }else{
                    message.warn(`${retMsg}`)
                }
            })
            we_dispute_types.push({"disputeType":'ALL',"disputeTypeText":'ALL'})
            this.setState({optionList:we_dispute_types})
        // })
    }
    downloadExcel=()=>{
        const {searchParams,data} = this.state
        if(searchParams && data.length){
            financial_download_report(searchParams).then(res=>{
                let URL = window.URL || window.webkitURL;
                let objectUrl = URL.createObjectURL(res);
                let a = document.createElement('a');
                a.href = objectUrl;
                a.download = 'data.xlsx';
                document.body.appendChild(a);
                a.click();
                a.remove();
            })
        }else{
            message.warn('No data found!')
        }
    }
    onFinish=(values)=>{
        this.setState({searchParams:null,data:[],loading:true})
        values.invoiceNo = values.invoiceNo?values.invoiceNo.split(','):undefined
        if(!Array.isArray(values.disputeNo)){
            values.disputeNo = values.disputeNo?values.disputeNo.split(','):undefined
        }
        values.claimReqNo = values.claimReqNo?values.claimReqNo:undefined
        values.bpReference = values.bpReference?values.bpReference:undefined
        values.claimId = values.claimId?values.claimId:undefined
        values.soldTo = values.soldTo?values.soldTo:undefined
        values.poNumber = values.poNumber?values.poNumber:undefined
        values.createdBy = values.createdBy?values.createdBy:undefined
        let createdOnFrom = values.createdOnFrom ? moment(values.createdOnFrom).format('YYYY-MM-DD') + '000000':undefined;
        let createdOnTo = values.createdOnTo ? moment(values.createdOnTo).format('YYYY-MM-DD') + '235959' : undefined;
        let params={
            ...values,
            createdOnFrom:createdOnFrom.split('-').join(''),
            createdOnTo:createdOnTo.split('-').join(''),
        }
        let {diffYearError,diffMonthError} = this.state;
        if(diffYearError){
            message.warn('Year of start date must be the same with that of end date')
            this.setState({loading:false})
        }else{
            if(diffMonthError){
                message.warn('Only date within 3 months are allowed to search')
                this.setState({loading:false})
            }else{
                financial_claim_search(params).then((res)=>{
                    const {retCode} = res;
                    if(retCode==='200'){
                        this.setState({data:res.data,searchParams:params,loading:false})
                    }else{
                        this.setState({loading:false})
                        message.warn(`${res.retMsg}`)
                    }
                })
            }
        }
    }
    handleOk=()=>{
        this.setState({isModalVisible:false})
    }
    handleCancel=()=>{
        this.setState({isModalVisible:false})
    }
    dpSplit=(e)=>{
        let value = e.target.value
        if (value.indexOf(" ") == -1) {

        } else {
            if(value){
                this.formRef.current.setFieldsValue({disputeNo:value.trim().split(/\s+/)})
            }
        }
    }
    dataChangeForm=(value)=>{
        let month = this.formRef.current.getFieldValue('createdOnTo').format('MM')-moment(value).format('MM');
        let year1 = moment(value).format('YYYY');
        let year2 = this.formRef.current.getFieldValue('createdOnTo').format('YYYY');
        if(year1===year2){
            this.setState({diffYearError:false})
            console.log()
            if(month>2){
                message.warn('Only date within 3 months are allowed to search')
                this.setState({diffMonthError:true})
            }else{
                this.setState({diffMonthError:false})
            }
        }else{
            message.warn('Year of start date must be the same with that of end date')
            this.setState({diffYearError:true})
        }
    }
    dataChangeTo=(value)=>{
        let month = moment(value).format('MM')-this.formRef.current.getFieldValue('createdOnFrom').format('MM')
        let year1 = moment(value).format('YYYY');
        let year2 = this.formRef.current.getFieldValue('createdOnFrom').format('YYYY')
        if(year1===year2){
            this.setState({diffYearError:false})
            if(month>2){
                message.warn('Only date within 3 months are allowed to search')
                this.setState({diffMonthError:true})
            }else{
                this.setState({diffMonthError:false})
            }
        }else{
            message.warn('Year of start date must be the same with that of end date')
            this.setState({diffYearError:true})
        }
    }
    render() {
        const { data,isModalVisible,basic_info,detailData,loading } = this.state;
        return <div>
            <HeaderNav parmas={'/claimReport'}/>
            <Layout className="site-layout-background claimReport" style={{ padding: '24px 0' }}>
                <div className="example" style={{display:loading?'block':'none'}}>
                    <Spin spinning={loading} />
                </div>
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    {detailData && <Modal title="Financial Claim Detail"
                                          width={1500}
                                          visible={isModalVisible}
                                          onOk={this.handleOk}
                                          onCancel={this.handleCancel}
                                          destroyOnClose={true}
                    >
                        <Form
                            name="FinancialClaimDetail"
                            labelCol={{span: 15}}
                            wrapperCol={{span: 10}}
                            preserve={false}
                        >
                            <Row>
                                <Col span={8}>
                                    <Form.Item
                                        label="Dispute Number"
                                        name="billingInstruction"
                                    >
                                        <span>{`${detailData[0].billingInstruction}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Claim Request No"
                                        name="claimReqNo"
                                    >
                                        <span>{`${detailData[0].claimReqNo}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Claim ID"
                                        name="claimId"
                                    >
                                        <span>{`${detailData[0].claimId}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Invoice No"
                                        name="invoiceNo"
                                    >
                                        <span>{`${detailData[0].invoiceNo}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Sold to Party"
                                        name="soldTo"
                                    >
                                        <span>{`${detailData[0].soldTo}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Bill to Party"
                                        name="billTo"
                                    >
                                        <span>{`${detailData[0].billTo}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Claim Category"
                                        name="claimCategory"
                                    >
                                        <span>{`${detailData[0].claimCategory}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Pricing Date"
                                        name="pricingDate"
                                    >
                                        <span>{`${detailData[0].pricingDate}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Requested Delivery Date"
                                        name="reqDeliveryDate"
                                    >
                                        <span>{`${detailData[0].reqDeliveryDate}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Sales Org"
                                        name="salesOrg"
                                    >
                                        <span>{`${detailData[0].salesOrg}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Currency"
                                        name="currency"
                                    >
                                        <span>{`${detailData[0].currency}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Purchase Order Number"
                                        name="poNumber"
                                    >
                                        <span>{`${detailData[0].poNumber}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Sales Office"
                                        name="salesOffice"
                                    >
                                        <span>{`${detailData[0].salesOffice}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="SBO-No/ SOP Ref. /Lenovo Ref"
                                        name="lenovoRef"
                                    >
                                        <span>{`${detailData[0].lenovoRef}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Channel"
                                        name="channel"
                                    >
                                        <span>{`${detailData[0].channel}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="BP-Reference"
                                        name="bpRef"
                                    >
                                        <span>{`${detailData[0].bpRef}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Country"
                                        name="country"
                                    >
                                        <span>{`${detailData[0].country}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Claim Type"
                                        name="claimType"
                                    >
                                        <span>{`${detailData[0].claimType}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Street/ House No"
                                        name="street"
                                    >
                                        <span>{`${detailData[0].street}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Street 2"
                                        name="street2"
                                    >
                                        <span>{`${detailData[0].street2}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Ship to Party"
                                        name="shipTo"
                                    >
                                        <span>{`${detailData[0].shipTo}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Postal Code"
                                        name="postalCode"
                                    >
                                        <span>{`${detailData[0].postalCode}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="City"
                                        name="city"
                                    >
                                        <span>{`${detailData[0].city}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Contact Person"
                                        name="contactPerson"
                                    >
                                        <span>{`${detailData[0].contactPerson}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Email"
                                        name="email"
                                    >
                                        <span>{`${detailData[0].email}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Phone number"
                                        name="phoneNumber"
                                    >
                                        <span>{`${detailData[0].phoneNumber}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Comment"
                                        name="comment"
                                    >
                                        <span>{`${detailData[0].comment}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Billing Instruction"
                                        name="billingInstruction"
                                    >
                                        <span>{`${detailData[0].billingInstruction}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Created Date"
                                        name="createdOn"
                                    >
                                        <span>{`${detailData[0].createdOn}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Created Time"
                                        name="createdTime"
                                    >
                                        <span>{`${detailData[0].createdTime}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Created By"
                                        name="createdBy"
                                    >
                                        <span>{`${detailData[0].createdBy}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Approved Date"
                                        name="approvedAt"
                                    >
                                        <span>{`${detailData[0].approvedAt}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Approved Time"
                                        name="approveTime"
                                    >
                                        <span>{`${detailData[0].approveTime}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Approved By"
                                        name="approvedBy"
                                    >
                                        <span>{`${detailData[0].approvedBy}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Changed Date"
                                        name="changeDate"
                                    >
                                        <span>{`${detailData[0].changeDate}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Changed Time"
                                        name="changedTime"
                                    >
                                        <span>{`${detailData[0].changedTime}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Changed By"
                                        name="changedBy"
                                    >
                                        <span>{`${detailData[0].changedBy}`}</span>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item style={{textAlign: 'right'}}>
                            </Form.Item>
                            <div style={{margin: '0 auto'}}>
                                <h1>Claim Item</h1>
                                <Table
                                    scroll={{y: 500}}
                                    columns={this.columnsItem}
                                    rowKey={'claimId'}
                                    dataSource={detailData}
                                    bordered
                                />
                            </div>
                        </Form>
                    </Modal>}
                    <h1>Financial Claim Report</h1>
                    <Form
                        name="internal"
                        labelCol={{ span:12 }}
                        wrapperCol={{ span: 12}}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        ref={this.formRef}
                    >
                        <Row>
                            <Col span={8}>
                                <Form.Item
                                    label="Dispute No"
                                    name="disputeNo"
                                    tooltip={'Dispute No can input multi-value and it should be separated by comma'}
                                    rules={[{ required: false }]}
                                >
                                    <Input onChange={this.dpSplit} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim Request No"
                                    name="claimReqNo"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="BP-Reference"
                                    name="bpReference"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim ID"
                                    name="claimId"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sold to Party"
                                    name="soldTo"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim Type"
                                    name="claimType"
                                    rules={[{ required: false }]}
                                >
                                    <Select dropdownMatchSelectWidth={240} placeholder={'Please select'}>
                                        {
                                            basic_info?basic_info.claimTypeList.map(item=>{
                                                return <Option value={item.TGT01} >{item.TGT01} | {item.TGT02}</Option>
                                            }):''
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Invoice Number"
                                    name="invoiceNo"
                                    tooltip={'Invoice No can input multi-value and it should be separated by comma'}
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim Category"
                                    name="claimCategory"
                                    rules={[{ required: false }]}
                                >
                                    <Select dropdownMatchSelectWidth={240} placeholder={'Please select'}>
                                        {
                                            basic_info?basic_info.claimCategoryList.map(item=>{
                                                return <Option value={item.TGT01} >{item.TGT01} | {item.TGT02}</Option>
                                            }):''
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Created By"
                                    name="createdBy"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sales Org"
                                    name="salesOrg"
                                    rules={[{ required: false }]}
                                >
                                    <Select dropdownMatchSelectWidth={240} placeholder={'Please select'}>
                                        {
                                            basic_info?basic_info.salesOrgList.map(item=>{
                                                return <Option value={item.TGT01} >{item.TGT01} | {item.TGT02}</Option>
                                            }):''
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Create From"
                                    name="createdOnFrom"
                                    rules={[{ required: true }]}
                                    initialValue={moment(new Date())}
                                >
                                    <DatePicker onChange={this.dataChangeForm} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Create To"
                                    name="createdOnTo"
                                    rules={[{ required: true }]}
                                    initialValue={moment(new Date())}
                                >
                                    <DatePicker onChange={this.dataChangeTo} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sales Office"
                                    name="salesOffice"
                                    rules={[{ required: false }]}
                                >
                                    <Select dropdownMatchSelectWidth={240} placeholder={'Please select'}>
                                        {
                                            basic_info?basic_info.salesOfficeList.map(item=>{
                                                return <Option value={item.TGT01} >{item.TGT01} | {item.TGT02}</Option>
                                            }):''
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Status"
                                    name="status"
                                    rules={[{ required: false }]}
                                >
                                    <Select
                                        mode="tags"
                                        placeholder="Please select"
                                        style={{ width: '150%' }}
                                    >
                                        <Option value={'FCRAT'}>FIN claim created</Option>
                                        <Option value={'FCHAN'}>FIN claim changed</Option>
                                        <Option value={'FDELE'}>FIN claim deleted</Option>
                                        <Option value={'FAPPR'}>FIN claim approved</Option>
                                        <Option value={'FREJE'}>FIN claim rejected</Option>
                                        <Option value={'FPROC'}>Processed</Option>
                                        <Option value={'FERRO'}>Error</Option>
                                        <Option value={'FCOMP'}>Complete</Option>
                                        <Option value={'LFCRA'}>Local FIN claim Req created</Option>
                                        <Option value={'FCRAF'}>FIN claim create failed</Option>
                                        <Option value={'LFCHA'}>Local FIN claim Req changed</Option>
                                        <Option value={'FCHAF'}>FIN claim change failed</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={16}>
                                <Form.Item
                                    label="Customer Purchase Order Number"
                                    name="poNumber"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Button style={{marginTop:20,marginBottom:20,float:'right'}}
                                type="primary"
                                htmlType="submit"
                        >
                            Search
                        </Button>
                    </Form>
                    <Button style={{marginTop:20}}
                            onClick={this.downloadExcel}
                            type="primary">
                        Export
                    </Button>
                    <Table
                        rowKey={'id'}
                        scroll={{y: 500}}
                        columns={this.columns}
                        dataSource={data}
                        bordered
                    />
                </Content>
            </Layout>
        </div>
    }
}

export default ClaimReport;